// import React from 'react'

// const Card = ({name,img}) => {
//   return (
//     <div class="services-item" data-aos="fade-up" data-aos-duration="600">
//         <div class="img-box">
//           <img src={img} alt=""/>
//         </div>
//         <h3>{name}</h3>
//         {/* <p>{img}</p> */}
//     </div>
//   )
// }

// export default Card

import React from 'react'

const Card = ({ name, img, onClick, dataAos, dataAosDelay }) => {
  return (
    <div
      className="services-item"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
      data-aos={dataAos || 'fade-up'}           // default 'fade-up'
      data-aos-delay={dataAosDelay || '0'}      // default 0ms
      data-aos-duration="800"
    >
      <div className="img-box">
        <img src={img} alt={`${name} - Professional cleaning service in Melbourne`} loading="lazy" />
      </div>
      <h3>{name}</h3>
    </div>
  );
};

export default Card
